import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { distinctUntilKeyChanged, filter, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthAction } from '../authentication/auth-action';
import { AuthService } from '../authentication/auth.service';
import { Account } from '../models/account';
import { AccountService } from '../services/account.service';
import { Notification, NotificationType } from './notification';
import { Channel } from 'pusher-js';
import Pusher from 'pusher-js';

@Injectable({
  providedIn: 'root',
})
export class PusherService {
  private readonly pusherEventName: string = 'notification';
  private readonly onPusherEventSubject$: Subject<Notification> = new Subject();
  private channel?: Channel;
  private pusher?: Pusher;

  onPusherEvent$: Observable<Notification> = this.onPusherEventSubject$.asObservable();

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
  ) {
    // Needs to be handled here as this service 
    // depends on AccountService an implementing it in AccountService would give a circular dependency.
    this.onPusherEvent$
      .pipe(
        filter(event => event.type == NotificationType.AccountUpdated),
        switchMap(() => this.accountService.fetchAccount())
      ).subscribe();

    this.onPusherEvent$.pipe(
      filter(x => x.type === NotificationType.EndOfDay),
      tap(() => this.authService.logout(false))
    ).subscribe();
  }

  initPusher(): void {
    this.accountService.account$
      .pipe(
        filter((account) => !!account.id),
        distinctUntilKeyChanged('id'),
      )
      .subscribe((account) => this.configurePusher(account));

    this.authService.onAuthChanged
      .pipe(filter((authAction) => authAction === AuthAction.Logout))
      .subscribe(() => {
        if (this.pusher && this.channel) {
          this.pusher.unsubscribe(this.channel.name);
        }
      });
  }

  private configurePusher(account: Account): void {
    this.pusher = new Pusher(environment.pusher.key, {
      cluster: 'eu',
      disableStats: true,
    });

    this.channel = this.pusher.subscribe(
      `courier_be_${account.branch.id}_${account.id}`
    );

    this.channel.bind(this.pusherEventName, (event: Notification) => {
      this.onPusherEventSubject$.next(event);
    });
  }
}
